import {ModelDisplayViewersApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const modelDisplayViewersApi = new ModelDisplayViewersApi(configuration);

export const requestModelDisplayViewers = (modelUuid: string) => {
  if (!modelUuid) {
    return Promise.resolve([]);
  }
  return modelDisplayViewersApi.getModelDisplayViewers({modelUuid});
};
